import { useContext } from 'react'
import { OkeMessagingContext } from '../contexts/OkeMessagingContext'

export default function useMessaging() {
  let {
    setArticleAction,
    messagingConnected,
    messagingLoggedIn,
    articles
  } = useContext(OkeMessagingContext)

  return {
    setArticleAction,
    messagingConnected,
    messagingLoggedIn,
    articles
  }
}
